import { useTranslation } from "react-i18next";

import { ButtonLink } from "simplydo/react/ui/button";
import {
  Message,
  MessageContent,
  MessageHeader,
} from "simplydo/react/ui/message";

import { useCurrentUser } from "utils/currentUser";

import AppStyledDashboard from "components/AppStyledDashboard";
import Login from "components/entry/Login";
import PointOfContactList from "components/lib/PointOfContactList";

type PageLoadErrorProps = { title: React.ReactNode; message?: React.ReactNode };

function PageLoadError({ title, message }: PageLoadErrorProps) {
  const user = useCurrentUser();
  const { t } = useTranslation();

  return (
    <AppStyledDashboard
      excludeWelcomeText
      scrolling={false}
      content={
        <>
          <Message>
            <MessageHeader>{title}</MessageHeader>
            {user ? (
              <MessageContent>{message}</MessageContent>
            ) : (
              <MessageContent>{t("entry.login.useFormToLogIn")}</MessageContent>
            )}
          </Message>

          {user && <PointOfContactList />}

          {!user ? (
            <Login embedded />
          ) : (
            <div>
              <ButtonLink color="primary" to="/">
                Return to homepage
              </ButtonLink>
            </div>
          )}
        </>
      }
    />
  );
}

export default PageLoadError;
